import React, { useMemo } from 'react';
import useLocale from '../hooks/useLocale';

/**
 * Универсальный PDF-вьюер:
 * - принимает src (URL / blob:ObjectURL),
 *   ИЛИ pdfUrl (старое имя пропса),
 *   ИЛИ pdfBase64 (строка base64 без префикса data:).
 * - height в пикселях
 */
const SimplePdfViewerIframe = ({ src, pdfUrl, pdfBase64, height = 900 }) => {
  const { getCurrentLanguage } = useLocale();
  const lang = getCurrentLanguage() || 'ru';

  const url = useMemo(() => {
    // 1) Выбираем исходный URL
    let raw = src || pdfUrl || null;

    // 2) Если есть base64 — формируем data: URL
    if (!raw && pdfBase64) {
      raw = `data:application/pdf;base64,${pdfBase64}`;
    }

    if (!raw) {
      return null;
    }

    // 3) Для http/https добавляем lang=, чтобы не ломать blob:/data:
    if (/^https?:\/\//i.test(raw)) {
      const hasLang = /[?&]lang=/.test(raw);
      if (hasLang) return raw;
      const sep = raw.includes('?') ? '&' : '?';
      return `${raw}${sep}lang=${encodeURIComponent(lang)}`;
    }

    // blob:, data:, file: и т.п. — отдаем как есть
    return raw;
  }, [src, pdfUrl, pdfBase64, lang]);

  if (!url) {
    return (
      <div
        style={{
          padding: '1rem',
          textAlign: 'center',
          color: '#666',
          fontSize: '0.9rem',
        }}
      >
        {lang === 'ru' ? 'PDF недоступен' : 'PDF is not available'}
      </div>
    );
  }

  return (
    <iframe
      key={url} // чтобы iframe пересоздавался при смене версии
      src={url}
      title="PDF Viewer"
      width="100%"
      height={height}
      style={{ border: 'none', display: 'block' }}
    />
  );
};

export default React.memo(SimplePdfViewerIframe);
